import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';
import OffersApi from '@/services/rest/bemob/offer';
import LandingsAPI from '@/services/rest/bemob/landing';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import {mixins} from 'vue-class-component';
import CreateCampaignDialogCountryMixin from '@/views/reports/mixins/flow/create-campaign-dialog-country-mixin';

@Component
export default class OffersLandingsSelectOptionsMixin extends mixins(ReportMixin,CreateCampaignDialogCountryMixin) {
  offersApi: OffersApi = new OffersApi();
  landingsApi: LandingsAPI = new LandingsAPI();

  offerOptions: Offer[] = []
  landingOptions: Landing[] = []

  form:{workspaceId:null,countryId:null}

  setOfferOptions() {
    const {uploadedForWorkspace, uploadedForCountryId, isAllInCache, data, isUploaded} = this.$store.state.cache.offers;
    if(isUploaded && isAllInCache) {
      return this.offerOptions = data.filter(item => (this.$store.getters.allPublicWorkspacesIds.includes(item.workspaceId) || item.workspaceId === this.form.workspaceId) &&   this.countryCondition({ form:this.form,item })  )
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === this.form.workspaceId && uploadedForCountryId === this.form.countryId){
      return this.offerOptions = [...data]
    }

    if(this.form.workspaceId === this.defaultWorkspace.id && this.form.countryId === 0){
      return this.offersApi.updateStoreCache({
        workspaceId: this.defaultWorkspace.id,
        countryId: 0
      }).then((res:Offer[])=>{
        this.offerOptions = res
      })
    }
    return this.offersApi.getList({
      status:'active',
      limit:'200',
      orderBy:'updated',
      orderDirection:'desc',
      columns:[ 'id', 'name' , 'countryId', 'affiliateNetworkId' ,'affiliateNetworkName', 'countryName', 'url'],
      workspaceId:this.form.workspaceId,
      ...(this.form.countryId!==0 && {countryId:this.form.countryId})
    }).then((res:Offer[])=>{
      this.offerOptions = res
    })
  }

  setLandingOptions() {
    const {uploadedForWorkspace, uploadedForCountryId, isAllInCache, data, isUploaded} = this.$store.state.cache.landings;
    if(isUploaded && isAllInCache) {
      return this.landingOptions = data.filter(item => (this.$store.getters.allPublicWorkspacesIds.includes(item.workspaceId) || item.workspaceId === this.form.workspaceId) &&   this.countryCondition({ form:this.form,item })  )
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === this.form.workspaceId && uploadedForCountryId === this.form.countryId){
      return this.landingOptions = [...data]
    }

    if(this.form.workspaceId === this.defaultWorkspace.id && this.form.countryId === 0){
      return this.landingsApi.updateStoreCache({
        workspaceId: this.defaultWorkspace.id,
        countryId: 0
      }).then((res:Landing[])=>{
        this.landingOptions = res
      })
    }
    return this.landingsApi.getList({
      status:'active',
      limit:'200',
      orderBy:'updated',
      orderDirection:'desc',
      columns:['name', 'nameFull', 'id', 'countryId', 'workspaceId'],
      workspaceId:this.form.workspaceId,
      ...(this.form.countryId!==0 && {countryId:this.form.countryId})
    }).then((res:Landing[])=>{
      this.landingOptions = res
    })
  }
}